// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-0069f736] .balance-control-clickable {\n  cursor: pointer;\n  -webkit-text-decoration: underline dotted;\n          text-decoration: underline dotted;\n}", ""]);
// Exports
module.exports = exports;
